import {
  TOGGLE_LIGHTBOX,
  SET_LIGHTBOX_IMAGE,
  SET_LIGHTBOX_VIDEO,
  CLEAR_LIGHTBOX_GALLERIES,
  SAVE_LIGHTBOX_GALLERY,
  POPULATE_LIGHTBOX_GALLERY,
} from '../constants/actionTypes';

export const toggleLightbox = (bool, isVideo = false) => ({
  type: TOGGLE_LIGHTBOX,
  bool,
  isVideo,
});

export const setLightboxImage = (galleryId, id, url, alt) => ({
  type: SET_LIGHTBOX_IMAGE,
  galleryId,
  id,
  url,
  alt,
});

export const setLightboxVideo = (url, isYoutube) => ({
  type: SET_LIGHTBOX_VIDEO,
  url,
  isYoutube
});

export const populateLightboxGallery = (id, galleryId, imgSrc, thumbSrc, alt) => ({
  type: POPULATE_LIGHTBOX_GALLERY,
  id,
  galleryId,
  imgSrc,
  thumbSrc,
  alt,
});

export const saveLightboxGallery = (galleryId) => ({
  type: SAVE_LIGHTBOX_GALLERY,
  galleryId,
});

export const clearLightboxGalleries = () => ({
  type: CLEAR_LIGHTBOX_GALLERIES,
});
